import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDm = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "DM",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 50.894 26.174",
	fill: "currentColor",
	stroke: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Combined-Shape",
			d: "M50.894,0V26.174H0V0ZM1.454,1.454V24.72H49.439V1.454Zm23.266,0h1.454V24.72H24.72Z",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_993",
			"data-name": "Path 993",
			d: "M20.934,15.968a5.54,5.54,0,0,0-1.207-4.042,3.947,3.947,0,0,0-2.894-1.105H12.82V21.13h4.013a3.947,3.947,0,0,0,2.894-1.105,5.575,5.575,0,0,0,1.207-4.057Zm-1.9,0a4.064,4.064,0,0,1-.742,2.894,2.04,2.04,0,0,1-1.454.582H14.7V12.507h2.138a2.04,2.04,0,0,1,1.454.582,4.027,4.027,0,0,1,.742,2.879Z",
			transform: "translate(-3.499 -2.953)",
			fillRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_994",
			"data-name": "Path 994",
			d: "M55.233,21.13V10.82h-2.4l-2.719,7.343-2.7-7.343H44.88V21.13H46.7V13.685l2.661,7.3H50.74l2.676-7.212V21.13Z",
			transform: "translate(-12.25 -2.953)",
			fillRule: "evenodd"
		})
	]
});
export default SvgDm;
